// extracted by mini-css-extract-plugin
export var container = "_h2-1";
export var cornerButtonContainer = "_h2-6";
export var disabled = "_h2-2";
export var dragActive = "_h2-3";
export var fileContainer = "_h2-5";
export var hiddenInput = "_h2-4";
export var widthContainer = "_h2-0";